export { default as Margins, type MarginsProps } from './Margins';
